import { lazy, Suspense } from 'react';
import { Box, CircularProgress } from '@mui/material';

/**
 * `emoji-picker-react`, loaded only when someone actually opens it.
 *
 * The package is ~310 kB raw / ~75 kB gzip. It was imported statically in four
 * files, all of which are reachable from the always-loaded app shell, so every
 * visitor downloaded the entire emoji database before the first paint — even on
 * the login screen, where there is nothing to put an emoji into.
 *
 * Every caller renders this inside a `<Popover>`, so nothing here is fetched
 * until the popover opens. The fallback keeps the popover from collapsing to
 * zero height for the moment the chunk is in flight.
 */
const EmojiPicker = lazy(() => import('emoji-picker-react'));

export default function LazyEmojiPicker({ width = 340, height = 420, ...props }) {
  return (
    <Suspense
      fallback={
        <Box
          sx={{
            width, height,
            display: 'flex', alignItems: 'center', justifyContent: 'center',
          }}
        >
          <CircularProgress size={22} />
        </Box>
      }
    >
      <EmojiPicker width={width} height={height} {...props} />
    </Suspense>
  );
}
